import './InputFileAvulso.css';

import { Loading } from '@elotech/components';
import { useLoading } from 'common/hooks';
import { useEffect, useMemo, useRef } from 'react';

import { getArquivoStorageService } from '../../service';

interface ParamInterface {
  valor: string;
  valorPadrao?: string;
  arquivo?: {
    id?: any;
    nome?: string;
  };
}

type Props<T> = {
  parametro: T;
  parametroIdGetter: (param: T) => number;
  onChange: (value: string) => void;
  onBusyChange?: (busy: boolean) => void;
  baseResourcePath?: string;
};

const ParamInputFile = <T extends ParamInterface>({
  parametro,
  onBusyChange,
  onChange,
  parametroIdGetter,
  baseResourcePath = ''
}: Props<T>) => {
  const parametroId = parametroIdGetter(parametro);
  const service = useMemo(
    () => getArquivoStorageService(baseResourcePath),
    [baseResourcePath]
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useLoading();
  const id = useMemo(
    () => `file-${Math.random().toString(36)}-${new Date().getTime()}`,
    []
  );

  useEffect(() => {
    onBusyChange?.(loading);
  }, [loading, onBusyChange]);

  const doChangeFile = async (file: File | undefined) => {
    if (!file) {
      inputRef.current!.value = '';
      onChange('');
      return;
    }

    const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
    if (!['jrxml', 'rpt', 'jasper'].includes(fileExtension)) {
      throw new Error(
        'Extensão de arquivo não permitida. Favor selecionar outro arquivo.'
      );
    }

    setLoading(
      service.postArquivoParametro(file).then(response => {
        onChange(response.data);
      })
    );
  };

  return (
    <div className="file-uploader">
      <Loading loading={loading} contain />
      <input
        type="file"
        ref={inputRef}
        id={id}
        className="file-uploader-input"
        onChange={event =>
          event?.target.files?.[0] &&
          setLoading(doChangeFile(event.target.files[0]))
        }
        title="Clique ou arraste para anexar"
      />

      <label
        className="input"
        htmlFor={id}
        data-title={
          loading
            ? 'Carregando...'
            : parametro.arquivo?.nome ||
              parametro.valor ||
              parametro.valorPadrao ||
              'Selecione um arquivo'
        }
      />

      <div className="file-uploader-icon" />
      {(parametro.valor || parametro.valorPadrao) && (
        <div
          className="file-downloader-icon"
          onClick={() =>
            setLoading(service.downloadArquivoParametro(parametroId))
          }
        />
      )}
      {parametro.valor && (
        <div
          className="file-remove-icon"
          onClick={() => setLoading(doChangeFile(undefined))}
        />
      )}
    </div>
  );
};

export default ParamInputFile;
